import isEmpty from 'lodash/isEmpty';
import { getIsAllowOnlineProductPickupEnabled } from '@tcp/core/src/reduxStore/selectors/session.selectors';
import { isCanada } from '../../../../../utils';
import { getLocalStorage } from '../../../../../utils/localStorageManagement';

// eslint-disable-next-line import/prefer-default-export
export const getStoreFilterData = (store) => {
  const storeData = store || JSON.parse(getLocalStorage('defaultStore')) || {};
  const storeId = storeData?.basicInfo?.id?.slice(-4) || '';
  let tcpWebOnlyBopisFilter = isCanada()
    ? '-TCPWebOnlyFlagCanadaStore:1'
    : '-TCPWebOnlyFlagUSStore:1';

  if (getIsAllowOnlineProductPickupEnabled()) {
    tcpWebOnlyBopisFilter = '';
  }
  return storeId ? `v_Quantity_${storeId}:[1 TO *]${tcpWebOnlyBopisFilter}` : '';
};

export const getStoreId = (store) => {
  const storeData = store || JSON.parse(getLocalStorage('defaultStore')) || {};
  return storeData?.basicInfo?.id?.slice(-4) || '';
};

export const getSelectedStoreL1Categories = (navigationData, shopThisStoreL1categories) => {
  return (
    navigationData?.filter(
      (item) =>
        item?.hasL2 > 0 &&
        item?.categoryContent?.displayToCustomer &&
        shopThisStoreL1categories?.includes(item?.categoryContent?.name)
    ) || []
  );
};

export const getSelectedStoreL2Categories = (
  shopThisStoreL1CategorySelection,
  storeL2categories
) => {
  const shopThisStoreL2categories = [];
  Object.entries(shopThisStoreL1CategorySelection?.subCategories || {}).forEach((category) => {
    if (
      category[1]?.label?.length &&
      category[1]?.hasSubCategory &&
      category[1]?.items?.some((value) => storeL2categories.includes(value?.categoryContent?.name))
    ) {
      shopThisStoreL2categories.push(category[1]);
    }
  });
  return shopThisStoreL2categories.sort((a, b) => a.order - b.order);
};

export const getDefaultL2CategoriesGroupingSelection = (shopThisStoreL1categorySelection) => {
  const shopThisStoreL2categories = [];
  if (!isEmpty(shopThisStoreL1categorySelection)) {
    Object.entries(shopThisStoreL1categorySelection?.subCategories || {}).forEach((category) => {
      if (category[1]?.hasSubCategory) {
        shopThisStoreL2categories.push(category[1]);
      }
    });
  }
  return shopThisStoreL2categories;
};

export default {
  getStoreFilterData,
};
